<template>
    <div class="uk-padding  uk-margin-remove-top uk-margin-remove-bottom">
        <div class="uk-container uk-container-small">
            <h2 class="uk-heading-line uk-text-center specHeading"><span>Alternate Entry Requirements</span></h2>
            <div class="uk-child-width-1-1" uk-grid>
                <div>
                    <p class="">
                        In the absence of a bachelor’s or master’s degree the applicant may apply for admission by Examination
                        or by Professional Experience alternative methods of entry. This admission criterion is for applicants
                        who do not meet the specified matriculation requirements for regular admission into either the
                        Master’s or the Doctoral programmes.
                        <br><br>
                        In other exceptions, degree equivalencies will be considered.
                    </p>
                </div>
                <div>
                    <div class="uk-child-width-1-2@m" uk-grid>
                        <div>
                            <h3 class="uk-heading-bullet specHeading"><span>Master's</span></h3>
                            <ul class="uk-list uk-list-bullet ">
                                To qualify for this admission status, Master’s applicants must:
                                <li>be over 25 years of age</li>
                                <li>sit and pass an English and/or Mathematics examination set by the Office of Graduate Studies and Research</li>
                                <li>submit certificates obtained from short courses from recognized institutions within the last ten
                                    years; these could also be reviewed to determine eligibility.</li>
                            </ul>
                        </div>
                        <div>
                            <h3 class="uk-heading-bullet specHeading"><span>Doctoral</span></h3>
                            <ul class="uk-list uk-list-bullet ">
                                To qualify for this admission status, Doctoral applicants must:
                                <li>be over 25 years of age</li>
                                <li>sit and pass an English and/or Mathematics examination set by the Office of Graduate Studies and  Research or,</li>
                                <li>
                                    have completed a Bachelor's degree at an accredited tertiary level institution
                                </li>
                                <li>submit certificates obtained from short courses from recognized institutions within the last ten
                                    years; these could also be reviewed to determine eligibility.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "alternateGradRequirements"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h2,h3{
            font-size: 1.1em !important;
        }
        h3{
            font-size: 1.1em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }

    }
</style>
